export const MAX_NUMBER_OF_REVOLUTIONS = 2
export const MIL_TO_MOA = 3.4377
export const DEFAULT_CONVERSION_RATE = 0.75;
export const DEFAULT_ROUNDING = 2;

export function formatPrice(price) {
  if (price === null || price === undefined) {
    return "N/A";  // Return "N/A" or any other default value you'd like
  }

  return parseFloat(price).toFixed(DEFAULT_ROUNDING);
}

export function priceInUsd(priceInCad, conversionRate = DEFAULT_CONVERSION_RATE) {
  let convertedPrice = Math.round(priceInCad * conversionRate);
  return formatPrice(convertedPrice);
}

export function toMetric(inputUnit, value) {
  switch (inputUnit) {
    case "in":
      return value * 2.54; // to centimeters
    case "ft":
      return value * 0.3048; // to meters
    case "fps":
      return value * 0.3048; // to meters per second
    case "fahrenheit":
      return (value - 32) * (5 / 9); // to celsius
    default:
      return value;
  }
};

export function toImperial(inputUnit, value, outputUnit) {
  switch (inputUnit) {
    case "cm":
      return value / 2.54; // to inches
    case "m":
      return value / (outputUnit === "yards" ? 0.9144 : 0.3048); // to feet or yards
    case "mps":
      return value / 0.3048; // to fps
    case "celsius":
      return value * (9 / 5) + 32; // to fahrenheit
    default:
      return value;
  }
};

export function calculationDataToImperial(calculationData) {
  return {
    zero_range: toImperial("m", calculationData.zero_range, "yards"),
    sight_height: toImperial("cm", calculationData.sight_height),
    initial_velocity: toImperial("mps", calculationData.initial_velocity),
    temperature: toImperial("celsius", calculationData.temperature),
    altitude: toImperial("m", calculationData.altitude)
  };
}

// These are the default values for the parameters dependent 
// on the type of unit (imperial or metric)

// NOTE: We don't set a different default value for Zero Range because we always want 
// to show round numbers on the front end (100, 200, 300, etc.)
export function defaultUnitParams(isImperial) {
  if (isImperial) {
    return {
      temperature: 59,
      altitude: 500,
      sightHeight: 1.5,
      initialVelocity: 3000,
    }
  }

  return {
    temperature: 15,
    altitude: 150,
    sightHeight: 3.8,
    initialVelocity: 915,
  }
}